import { gql } from '@apollo/client';

export const MY_PROFILE = gql`
  fragment MyProfile on Profile {
    id
    type
    name
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
    contactAddressId
    contactAddress {
      id
      street1
      street1
      city
      state
      zip
    }
    billingAddressId
    billingAddress {
      id
      street1
      street1
      city
      state
      zip
    }
    phones {
      id
      subType
      value
    }
    emails {
      id
      subType
      value
    }
    perms
    user {
      profileId
      email
    }
  }
`;

export const COMPANY_CREDENTIALS = gql`
  fragment CompanyCredentials on Credential {
    id
    type
    issuer
    value
    city
    state
    issueDate
    expireDate
    isDefault
    created
    updated
    image {
      contentType
      size
      thumb(size: 350)
      url
    }
  }
`;

export const GET_MY_COMPANY_PROFILE = gql`
  ${MY_PROFILE}
  ${COMPANY_CREDENTIALS}
  query GetMyProfile {
    me {
      ...MyProfile
      credentials(where: { type: "BUSINESS_LICENSE", archived: null }) {
        ...CompanyCredentials
      }
    }
    stripePlatformCustomer {
      defaultPaymentMethod {
        id
        type
        # Card fields
        brand
        expMonth
        expYear
        last4
        # US Bank Account fields
        bankName
        accountHolderType
        accountType
        routingNumber
      }
    }
  }
`;
